<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="grid">
            <div class="md:col-8 sm:col-12 comp-grid">
              <div class="card">
                <div class="text-xl text-primary font-bold">Edit Account</div>
              </div>
              <Breadcrumb
                :home="{
                  icon: 'pi pi-arrow-left text-lg mr-3',
                  label: 'Back',
                  command: () => {
                    $router.go(-1);
                  },
                }"
                :model="[
                  {
                    label: 'Accounts',
                    to: '/third_party_agencies_accounts',
                  },
                  {
                    label: 'Edit',
                    to: `/third_party_agencies_accounts/edit/${id}`,
                  },
                ]"
              />
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="md:col-8 sm:col-12 comp-grid">
            <div class="card nice-shadow-18">
              <div>
                <template v-if="!loading">
                  <div class="grid">
                    <div class="col-12">
                      <form
                        ref="observer"
                        tag="form"
                        @submit.prevent="startRecordUpdate()"
                      >
                        <!--[form-content-start]-->
                        <div class="grid">
                          <div class="col-12 md:col-6">
                            <div class="mb-2 font-bold text-sm">Full Name</div>
                            <div class="">
                              <InputText
                                ref="ctrlname"
                                v-model.trim="formData.name"
                                label="Name"
                                type="text"
                                placeholder="Name"
                                class="w-full"
                                pattern="^[A-Za-z-', ]+$"
                                :class="getErrorClass('name')"
                              >
                              </InputText>
                            </div>
                          </div>

                          <div class="col-12 md:col-6">
                            <div class="mb-2 font-bold text-sm">Telephone</div>
                            <div class="">
                              <InputText
                                ref="ctrltelephone"
                                v-model.trim="formData.telephone"
                                label="Telephone"
                                type="text"
                                class="w-full"
                                placeholder="Eg. 0209013836"
                                pattern="^[0-9]+$"
                                maxlength="10"
                                minlength="10"
                                :class="getErrorClass('telephone')"
                              >
                              </InputText>
                            </div>
                          </div>

                          <div class="col-12 md:col-6">
                            <div class="mb-2 font-bold text-sm">Username *</div>
                            <div class="">
                              <InputText
                                ref="ctrlusername"
                                v-model.trim="formData.username"
                                label="Username"
                                type="text"
                                placeholder="Enter Username"
                                class="w-full"
                                pattern="^[0-9A-Za-z-_@.]+$"
                                :disabled="true"
                                :class="getErrorClass('username')"
                              >
                              </InputText>
                            </div>
                          </div>

                          <div class="col-12 md:col-6">
                            <div class="mb-2 font-bold text-sm">Email *</div>
                            <div class="">
                              <InputText
                                ref="ctrlemail"
                                v-model.trim="formData.email"
                                label="Email"
                                type="email"
                                placeholder="Email Address"
                                class="w-full"
                                :disabled="true"
                                :class="getErrorClass('email')"
                              >
                              </InputText>
                            </div>
                          </div>

                          <div class="col-12 md:col-6">
                            <div class="mb-2 font-bold text-sm">
                              Account Type *
                            </div>
                            <div class="">
                              <Dropdown
                                class="w-full"
                                :class="getErrorClass('account_type')"
                                optionLabel="label"
                                optionValue="value"
                                ref="ctrlaccount_type"
                                v-model="formData.account_type"
                                :options="$menus.account_typeItems"
                                label="Account Type"
                                placeholder="Select ..."
                              >
                              </Dropdown>
                            </div>
                          </div>

                          <div class="col-12 md:col-6">
                            <div class="mb-2 font-bold text-sm">
                              Account Status *
                            </div>
                            <div class="">
                              <Dropdown
                                class="w-full"
                                :class="getErrorClass('account_status')"
                                optionLabel="label"
                                optionValue="value"
                                ref="ctrlaccount_status"
                                v-model="formData.account_status"
                                :options="$menus.account_statusItems"
                                label="Account Status"
                                placeholder="Select ..."
                              >
                              </Dropdown>
                            </div>
                          </div>
                        </div>
                        <!--[form-content-end]-->
                        <div v-if="showSubmitButton" class="text-center my-3">
                          <Button
                            type="submit"
                            label="Update"
                            icon="pi pi-send"
                            :loading="saving"
                          />
                        </div>
                      </form>
                      <slot :submit="submit" :saving="saving"></slot>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="p-3 text-center">
                    <ProgressSpinner style="width: 50px; height: 50px" />
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { PageMixin } from "../../mixins/page.js";
import { EditPageMixin } from "../../mixins/editpage.js";
import { mapActions, mapGetters, mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import {
  required,
  email,
  sameAs,
  minLength,
  maxLength,
  minValue,
  maxValue,
  numeric,
  integer,
  decimal,
  ipAddress,
} from "@vuelidate/validators";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  name: "editThirdpartyagenciesaccountsPage",
  components: {},
  mixins: [PageMixin, EditPageMixin],
  props: {
    pageName: {
      type: String,
      default: "third_party_agencies_accounts",
    },
    idName: {
      type: String,
      default: "third_party_agency_account_id",
    },
    routeName: {
      type: String,
      default: "third_party_agencies_accountsedit",
    },
    pagePath: {
      type: String,
      default: "third_party_agencies_accounts/edit",
    },
    apiPath: {
      type: String,
      default: "third_party_agencies_accounts/edit",
    },
  },
  data() {
    return {
      formData: {
        username: "",
        email: "",
        telephone: "",
        name: "",
        account_type: "",
        account_status: "",
      },
      submitted: false,
    };
  },
  computed: {
    pageTitle: {
      get: function () {
        return "Edit Account";
      },
    },
    currentRecord: {
      get: function () {
        return this.$store.getters[
          "third_party_agencies_accounts/currentRecord"
        ];
      },
      set: function (value) {
        this.$store.commit(
          "third_party_agencies_accounts/setCurrentRecord",
          value
        );
      },
    },
  },
  validations() {
    let formData = {
      username: { required },
      account_type: { required },
      account_status: { required },
      email: { required, email },
      telephone: {},
      name: {},
    };
    return { formData };
  },
  methods: {
    ...mapActions("third_party_agencies_accounts", [
      "updateRecord",
      "fetchRecord",
    ]),
    async startRecordUpdate() {
      this.submitted = true;
      const isFormValid = !this.v$.$invalid;
      if (!isFormValid) {
        this.flashMsg("Please complete the form", "Form is invalid", "error");
        return;
      }
      this.saving = true;
      let id = this.id;
      let url = this.apiUrl;
      let payload = this.normalizedFormData();
      let data = { id, url, payload };
      this.updateRecord(data).then(
        (response) => {
          this.saving = false;
          this.flashMsg(this.msgAfterUpdate);
          this.resetForm();
          this.closeDialogs(); // close page dialog that if opened
          if (this.redirect) this.navigateTo(`/third_party_agencies_accounts`);
        },
        (response) => {
          this.saving = false;
          this.showPageRequestError(response);
        }
      );
    },
    updateFormFields: function () {
      //update form fields value after load from api
      //e.g convert fieldvalue (value,value2,value2) to array
    },
    resetForm() {
      //reset form fields value
      this.formData = {
        username: "",
        email: "",
        telephone: "",
        name: "",
        account_type: "",
        account_status: "",
      };
      //raise event to reset other custom form components
      //this.$EventBus.$emit("resetForm");
    },
    getErrorClass(field) {
      if (this.v$.formData[field].$invalid && this.submitted) {
        return "p-invalid";
      }
      return "";
    },
  },
  watch: {},
  async mounted() {},
  async created() {},
};
</script>
<style scoped></style>
